import React from 'react';
import {Link} from 'react-router-dom';
import {HeaderDatePicker} from '@/components/header/header_date_picker/HeaderDatePicker';

interface BreadcrumbItem {
    key: string;
    text: string;
    href: string;
}

interface BreadcrumbProps {
    items: BreadcrumbItem[];
    activeTab?: string;
    activeTabTitle?: string;
    showDateRangePicker?: boolean;
    showComparisonDatePicker?: boolean;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
    items,
    activeTab,
    activeTabTitle,
    showDateRangePicker = false,
    showComparisonDatePicker = false
}) => {
    const containerStyle: React.CSSProperties = {
        //backgroundColor: '#f8f9fa',
        //padding: '0.75rem 1rem',
        //borderBottom: '1px solid #dee2e6',
        fontSize: '0.875rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '1rem'
    };

    const breadcrumbNavStyle: React.CSSProperties = {
        flex: 1,
        minWidth: 0,
        marginBottom: '1.5rem',
        marginTop: '.1rem',
        marginLeft: '.1rem',
        marginRight: '.1rem',
        backgroundColor: 'transparent'
    };

    const datePickerContainerStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        //gap: '0.5rem',
        alignItems: 'flex-end',
        flexShrink: 0
    };

    const datePickerWrapperStyle: React.CSSProperties = {
        display: 'block',
        whiteSpace: 'nowrap'
    };

    return (
        <div style={containerStyle}>
            <style>{`
        .breadcrumb-item + .breadcrumb-item::before {
          content: ">" !important;
        }
      `}</style>
            <nav className="breadcrumb to nav mb-3 pl-0" style={breadcrumbNavStyle}>
                {items.map((item, index) => (
                    <li key={item.key} className="breadcrumb-item">
                        {index < items.length - 1 ? (
                            <Link to={item.href} className="text-decoration-none">{item.text}</Link>
                        ) : (
                            <Link to={item.href} aria-current="page" className="text-decoration-none">{item.text}</Link>
                        )}
                    </li>
                ))}

                {activeTab && activeTabTitle && (
                    <li className="breadcrumb-item">
                        <span aria-current="page">{activeTabTitle}</span>
                    </li>
                )}
            </nav>

            {(showDateRangePicker || showComparisonDatePicker) && (
                <div style={datePickerContainerStyle}>
                    {showDateRangePicker && (
                        <div style={datePickerWrapperStyle}>
                            <HeaderDatePicker comparableType={false} />
                        </div>
                    )}
                    {showComparisonDatePicker && (
                        <div style={datePickerWrapperStyle}>
                            <HeaderDatePicker comparableType={true} />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Breadcrumb;
